export default __webpack_public_path__ + "static/media/Bracers of the Berserker's Fury.b3c3ec6b.jpg";